import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import { Carousel } from 'antd';
import { BASE_IMG_URL } from '@images/imageUrls';
import { CommonAction } from '@stores/common/action';
import FeedbackProblemPicker, {
    parseProblemCategories,
    type FeedbackProblemCategory,
    type FeedbackProblemItem,
} from '@components/feedbackProblemPicker';
import updateImageListSrc from '@utils/update-image-list-src'


interface HomeH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    common?: CommonAction
    thread?: ThreadAction;
    setPost?: any;
    threadList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    userInfo?: any;
}
interface HomeH5PageState {
    bannerList: any;
    loading: boolean;
    error: any
    pageLoaded: any
    topicList: any
    userList: any
    isChanging: boolean;
    publishPopupStatus: boolean;
    feedbackProblemPickerVisible: boolean;
    feedbackProblemCategories: FeedbackProblemCategory[];
}
@inject('app', 'site', 'user', 'thread', 'common', 'setPost')
@observer
class HomeH5Page extends BasePage<HomeH5PageProps, HomeH5PageState> {
    changeTimer:any = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        bannerList: [],
        topicList: [],
        userList: [],  // 关注用户列表
        isChanging: false,
        publishPopupStatus: false,  // 选择发帖类型弹框
        feedbackProblemPickerVisible: false,
        feedbackProblemCategories: [],
    };
    componentDidMount() {
        const { app, user, thread, common } = this.props;
        
        if (thread) {
            let params: any = {
                "page[number]": 1,
                "page[size]": 20
            }
            thread.getThreadList(params)
        }
        if(common) {
            let bannerParams = {
                type: 1,
                category: 1
            }
            common.getBannerList(bannerParams).then((res) => {
                this.setState({
                    bannerList: res.data?.list
                })
            });
            
            
        }
        super.componentDidMount();
    }

    componentWillUnmount() {
        // 组件卸载时清理定时器
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
    }

    // 处理轮播图切换前的回调
    handleBeforeChange = () => {
        this.setState({ isChanging: true });
        
        // 清理之前的定时器
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
        
        // 设置50ms后重置isChanging状态
        this.changeTimer = setTimeout(() => {
            this.setState({ isChanging: false });
        }, 50);
    }

    // 处理图片点击事件
    handleImageClick = (data) => {
        if (!this.state.isChanging) {
        window.location.href = data.targe_url?.[1]?.url;;
        }
    }

    // 跳转到话题详情页
    handleTopicClick = (id: string | number) => {
        this.props.history && this.props.history.push(`/topic/${id}`);
    };

    openFeedbackProblemPicker = async () => {
        this.setState({ publishPopupStatus: false });

        const { thread } = this.props;
        const { feedbackProblemCategories } = this.state;
        if (!feedbackProblemCategories.length && thread?.getFeedbackProblems) {
            try {
                const res = await thread.getFeedbackProblems();
                const categories = parseProblemCategories(res);
                this.setState({
                    feedbackProblemCategories: categories,
                    feedbackProblemPickerVisible: true,
                });
                return;
            } catch (error) {
                console.error('[HomeH5Page] load feedback problems failed:', error);
            }
        }

        this.setState({ feedbackProblemPickerVisible: true });
    };

    handleFeedbackProblemConfirm = (problem: FeedbackProblemItem | null) => {
        const { setPost, history } = this.props;
        const problemId = String(problem?.value ?? problem?.id ?? '');
        const problemName = problem?.name || '';
        const problemSolvedCount = Number(problem?.solvedCount ?? 0) || 0;

        if (setPost?.clearPostData) {
            setPost.clearPostData();
        }
        if (setPost?.setPostData) {
            setPost.setPostData({
                type: 2,
                topicIds: [],
                source: 'H5',
                problemId,
                problemName,
                problemSolvedCount,
            });
        }

        this.setState({ feedbackProblemPickerVisible: false }, () => {
            history.push('/setFeedbackPost');
        });
    };


    // 帖子列表
    renderThreadList = () => {
        const { threadList, loading, hasMore, onLoadMore } = this.props;
        return (
            <div className={styles.threadListBox}>
                <ThreadList data={threadList} showRecommendUserList={true} loading={loading} hasMore={hasMore} onLoadMore={onLoadMore}></ThreadList>
                {/* {loading && <div className={styles.loading}>加载中...</div>}
                {!hasMore && !loading && <div className={styles.loading}>没有更多了</div>} */}
            </div>
        )
    }

    render() {
        let { bannerList, userList, publishPopupStatus } = this.state;
        return ( <div className={styles.wrapper}>
            <div className={styles.carouselBox}>
                <Carousel
                    autoplay={true}
                    autoplaySpeed={2000}
                    draggable={true}
                    className={styles.CarouselList}
                    dots={{ className: styles.customDots }}
                    beforeChange={this.handleBeforeChange}
                >
                    {bannerList?.map((item: any) => (
                        <img
                            src={updateImageListSrc(item.img_url, 24)}
                            className={styles.carouselImg}
                            onClick={() => this.handleImageClick(item)}
                        />
                    ))}
                </Carousel>
            </div>
            
           {this.renderThreadList()}
           <div className={styles.publishEnter} onClick={() =>
                window.globalEnsureLogin(() => {
                    // this.props.history.push(`/setPost`)
                    this.setState({publishPopupStatus: true})
                })}>
                <img src={`${BASE_IMG_URL}/common/publish2.png`} alt="" className={styles.publishIcon}/>
           </div>

            {/* 选择发布类型 */}
            {publishPopupStatus && <div className={styles.publishPopup}>
                <div className={styles.publishPopupContent}>
                    <img src={`${BASE_IMG_URL}/common/close4.png`} alt="" className={styles.close} onClick={() => {
                        this.setState({publishPopupStatus: false})
                    }}/>
                    <div className={styles.publishItem} onClick={() => {
                        this.props.history.push(`/setPost`)
                    }}>
                        <img src={`${BASE_IMG_URL}/common/publish3.png`} alt="" className={styles.publishIcon}/>
                        <div className={styles.infoBox}>
                            <div className={styles.title}>发图文</div>
                            <div className={styles.info}>图文视频，分享精彩视界</div>
                        </div>
                        <img src={`${BASE_IMG_URL}/common/arrow_r4.png`} alt="" className={styles.arrow}/>
                    </div>
                    <div className={styles.publishItem} onClick={this.openFeedbackProblemPicker}>
                        <img src={`${BASE_IMG_URL}/common/publish4.png`} alt="" className={styles.publishIcon}/>
                        <div className={styles.infoBox}>
                            <div className={styles.title}>问题反馈</div>
                            <div className={styles.info}>遇到问题？戳这里反馈</div>
                        </div>
                        <img src={`${BASE_IMG_URL}/common/arrow_r4.png`} alt="" className={styles.arrow}/>
                    </div>
                </div>
            </div>}
            <FeedbackProblemPicker
                visible={this.state.feedbackProblemPickerVisible}
                categories={this.state.feedbackProblemCategories}
                onClose={() => this.setState({ feedbackProblemPickerVisible: false })}
                onConfirm={this.handleFeedbackProblemConfirm}
            />
        </div>) 
    }
}

export default withRouter(HomeH5Page);
